import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CheckInviteResponse } from '@shared/invite/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({ providedIn: 'root' })
export class PublicInviteApiService {
  private readonly path = '/public/invite';

  constructor(private readonly http: ApiClientService) {}

  check(token: string): Observable<CheckInviteResponse> {
    return this.http.post<CheckInviteResponse>(`${this.path}/check-invite/${token}`, {});
  }

  decline(token: string): Observable<void> {
    return this.http.post<void>(`${this.path}/${token}/decline`, {});
  }
}
